<!-- START Dialog: Start Trial -->
<p-dialog header="" [(visible)]="showDialog" [style]="{ width: '40vw' }" [closable]="true" [closeOnEscape]="true" [modal]="true">
    <div
        class="text-center mb-16"
        style="
            background-image: url(&quot;../../../../assets/images/trial-upgrade.png&quot;);
            height: 16vh;
            background-size: contain;
            background-repeat: no-repeat;
            background-position-x: center;
        "
    ></div>

    <ng-template pTemplate="content">
        <h1 class="title-h1 mb-4 text-center">{{ "dialog_starttrial_header" | translate }}</h1>
        <p class="mb-4 text-center" [innerHTML]="'dialog_starttrial_text1' | translate"></p>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="text-center">
            <p-button
                pRipple
                type="button"
                styleClass="p-button-lg"
                label="{{ 'dialog_starttrial_button' | translate }}"
                (click)="startFreeTrialClicked.emit()"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: Start Trial -->
